<template>
    <div class="app-footer bg-zinc-100 border-t-2 border-zinc-200">
        <layout-contained>
            <div class="pt-8 pb-10 flex flex-col space-y-5">
                <span class="text-zinc-900">
                    &copy; {{ new Date().getFullYear() }}
                    {{ $config.public.companyNameLong }}
                    | <NuxtLink class="hover:underline" to="/">Home</NuxtLink> |
                    <NuxtLink class="hover:underline" to="/videos">Videos</NuxtLink> |
                    <NuxtLink class="hover:underline" to="/contact">Contact</NuxtLink> |
                    <NuxtLink class="hover:underline" to="/terms">Terms</NuxtLink> |
                    <NuxtLink class="hover:underline" to="/privacy">Privacy</NuxtLink> |
                    <NuxtLink class="hover:underline" to="/cookies">Cookies</NuxtLink> | Website by
                    <a class="hover:underline" href="https://www.triplestep.tv/">Triple Step TV</a>
                </span>
                <button-donation></button-donation>
            </div>
        </layout-contained>
    </div>
</template>

<script>
export default {
    name: 'AppFooter',
};
</script>
